import { Rng } from './deterministic';

export function getGateRowBudget(level: number): 3 | 4 | 5 {
  if (level <= 1) return 3;
  if (level <= 3) return 4;
  return 5;
}

export function getCandidateGateRowIndices(totalCandidateRows: number, level: number): number[] {
  const budget = getGateRowBudget(level);
  const preferredByBudget: Record<3 | 4 | 5, number[]> = {
    3: [0, 2, 4],
    4: [0, 2, 4, 5],
    5: [0, 1, 2, 4, 5],
  };
  const preferred = preferredByBudget[budget]
    .filter((index) => index >= 0 && index < totalCandidateRows);
  if (preferred.length === budget) {
    return preferred;
  }

  // Fallback for non-standard template row counts: pick evenly spaced rows.
  const selected: number[] = [];
  const targetCount = Math.min(budget, totalCandidateRows);
  for (let i = 0; i < targetCount; i++) {
    const index = Math.round(((i + 1) / (targetCount + 1)) * (totalCandidateRows - 1));
    if (!selected.includes(index)) {
      selected.push(index);
    }
  }
  for (let index = 0; selected.length < targetCount && index < totalCandidateRows; index++) {
    if (!selected.includes(index)) {
      selected.push(index);
    }
  }
  return selected.sort((left, right) => left - right);
}

export function getOpeningEnemyCount(_level: number, _rng: Rng): number {
  // Every mission starts from one commando, so the pre-gate beat must test the
  // weapon without allowing seed variance to decide the run. Difficulty begins
  // scaling after the first growth choice, when the player has recovery room.
  return 2;
}
